import { render, staticRenderFns } from "./BaseCheckboxLabel.vue?vue&type=template&id=04de2aea&scoped=true&"
import script from "./BaseCheckboxLabel.vue?vue&type=script&lang=js&"
export * from "./BaseCheckboxLabel.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckboxLabel.vue?vue&type=style&index=0&id=04de2aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de2aea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
